"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DbGuidePlaceDevelopmentView = void 0;
var React = require("react");
var DbGuideLocationGroup_1 = require("@/pages/dbguide/states/DbGuideLocationGroup");
var DbGuideSliderView_1 = require("@/pages/dbguide/components/DbGuideSliderView");
exports.DbGuidePlaceDevelopmentView = function (props) {
    var onBackClick = function () { return props.onBackClick(); };
    var onViewMap = function () { return props.onViewMap(); };
    var onPlaceClick = function (place) { return function () { return props.onPlaceClick(place); }; };
    var renderLocation = function (location, i) {
        if (location.type === DbGuideLocationGroup_1.DbGuideLocationType.WALKING) {
            var renderWalkTableRow = function (row, j) {
                var distanceText = row.distanceValue ? row.distanceValue + " " + row.distanceUnit : 'n/a';
                return (React.createElement("tr", { key: j },
                    React.createElement("td", null,
                        React.createElement("a", { onClick: onPlaceClick(row), href: "#" }, row.name)),
                    React.createElement("td", null, distanceText)));
            };
            return (React.createElement("div", { key: i },
                React.createElement("div", { className: "c-guides__method" },
                    React.createElement("div", { className: "c-guides__methodtext" }, "Walking"),
                    React.createElement("div", { className: "c-guides__methodimg" },
                        React.createElement("img", { src: "https://ww2.okay.com/search/map/images/transport-img.png", alt: "" }))),
                React.createElement("div", { className: "c-guides__table" },
                    React.createElement("table", null,
                        React.createElement("tbody", null,
                            React.createElement("tr", null,
                                React.createElement("th", null, "Location"),
                                React.createElement("th", { style: { width: '120px' } }, "Distance (KM)")),
                            location.locations.map(renderWalkTableRow))))));
        }
        if (location.type === DbGuideLocationGroup_1.DbGuideLocationType.BUS) {
            var renderBusTableRow = function (row, j) {
                var scheduleLink = row.link && row.link.startsWith('http') ?
                    (React.createElement("a", { target: "_blank", href: row.link }, "Schedule")) : (React.createElement("span", null, "n/a"));
                var durationText = row.durationValue ?
                    (React.createElement("span", null, row.durationValue + " " + row.durationUnit)) :
                    (React.createElement("span", null, "n/a"));
                return (React.createElement("tr", { key: j },
                    React.createElement("td", null, row.name),
                    React.createElement("td", null, row.routeName ? row.routeName : 'n/a'),
                    React.createElement("td", null, durationText),
                    React.createElement("td", null, scheduleLink)));
            };
            return (React.createElement("div", { key: i },
                React.createElement("div", { className: "c-guides__method" },
                    React.createElement("div", { className: "c-guides__methodtext" }, "Bus"),
                    React.createElement("div", { className: "c-guides__methodimg" },
                        React.createElement("img", { src: "https://ww2.okay.com/Search/Map/images/bus-transport-img.png", alt: "" }))),
                React.createElement("div", { className: "c-guides__table" },
                    React.createElement("table", null,
                        React.createElement("tbody", null,
                            React.createElement("tr", null,
                                React.createElement("th", null, "Dest."),
                                React.createElement("th", null, "Bus"),
                                React.createElement("th", null, "Dur."),
                                React.createElement("th", null, "Link")),
                            location.locations.map(renderBusTableRow))))));
        }
    };
    var renderLocationSection = function (props) {
        if (!props.location || !props.location.length)
            return;
        return (React.createElement("div", { className: "c-guides__section" },
            React.createElement("div", { className: "c-guides__head" },
                React.createElement("span", null, "Location"),
                React.createElement("span", { className: "c-guides__titleaction" })),
            props.location.map(renderLocation)));
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: "c-guides__nav" },
            React.createElement("div", { onClick: onBackClick, id: "back", className: "c-guides__back" },
                React.createElement("span", { className: "fas fa-chevron-left" })),
            React.createElement("div", { className: "c-guides__title" }, props.name),
            React.createElement("div", { className: "c-guides__done" })),
        React.createElement("div", { className: "c-guides__body" },
            React.createElement("div", { className: "c-guides__section" },
                React.createElement(DbGuideSliderView_1.DbGuideSliderView, { photos: props.photos, onSliderNextClick: props.onSliderNextClick, onSliderPrevClick: props.onSliderPrevClick }),
                React.createElement("div", { className: "c-guides__text" }, props.description)),
            renderLocationSection(props),
            React.createElement("div", { className: "c-guides__section" },
                React.createElement("div", { className: "c-guides__head" },
                    React.createElement("span", null, "Properties"),
                    React.createElement("span", { className: "c-guides__titleaction" })),
                React.createElement("div", { className: "c-guides__text" },
                    "View OKAY.com's property listings for ",
                    props.name,
                    " using the links below."),
                React.createElement("div", { className: "c-guides__ctas" },
                    React.createElement("a", { target: "_blank", href: props.rentLink, className: "c-guides__cta" },
                        "For Rent",
                        React.createElement("span", { className: "c-guides__ctaicon" },
                            React.createElement("span", { className: "fas fa-search" }))),
                    React.createElement("a", { target: "_blank", href: props.saleLink, className: "c-guides__cta" },
                        "For Sale",
                        React.createElement("span", { className: "c-guides__ctaicon" },
                            React.createElement("span", { className: "fas fa-search" })))))),
        React.createElement("div", { className: "c-guides__footer" },
            React.createElement("a", { onClick: onViewMap, className: "c-guides__footer-action", href: "#" },
                React.createElement("span", { className: "fas fa-map" }),
                "View Map"))));
};
